export const resetCategories = resp => ({
  type: "RESET_CATEGORIES"
});

export const fetchCategories = resp => ({
  type: "FETCH_CATEGORIES",
  payload: resp
});

export const saveCategory = resp => ({
  type: "SAVE_CATEGORY",
  payload: resp
});

export const removeCategory = id => ({
  type: "REMOVE_CATEGORY",
  id
});
export const setCategories = categories => ({
  type: "SET_CATEGORIES",
  categories
});



// WEBPACK FOOTER //
// ./src/actions/actions/category.js